/**
 * es6 自研接口
 */
;
(function () {
  window.theme = window.theme || {};
  if (window && window.theme) {
    const api = window.Bloom.global.api_url;
    let loginPromise = null;
    let temporaryPromise = null;
    window.cartSynced = false;
    theme.fetch = {
      /**
       *
       * @param {*} url
       * @returns
       */
      checkUrl(url) {
        return /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/.test(url)
      },
      /**
       * 通用fetch方法
       * @param {*} url
       * @param {*} options
       * @returns
       */
      query(url, options = {}) {
        const requrl = this.checkUrl(url) ? url : `${api}${url}`
        let token = window.localStorage.getItem('access_token') || '' // get auth token
        if (!token) {
          // 传生成的token
          const getTemporaryTustomer = this.getTemporaryTustomer()
          token = getTemporaryTustomer.token || ''
        }
        const method = options.method ? options.method.toUpperCase() : 'GET'
        const headers = {
          "Content-Type": "application/json",
          'User-Location': window.Bloom?.local_info?.user_local || '',
          Authorization: token,
          ...options.headers
        }
        let reqbody = ''
        if (method === 'POST') {
          reqbody = options.body || ''
        }
        if (headers['Content-Type'].match(/^application\/json$/i) && requrl.indexOf('web') > -1 && bloomchicLib) {
          Object.assign(headers, bloomchicLib.createSign(requrl, reqbody))
        }
        delete options.headers // 删除headers
        return fetch(requrl, {
          method,
          headers,
          ...options,
        })
          .then((response) => response.json())
          .then(async (result) => {
            if (result.code == 401) {
              this.clearCustomerLogin()
              // window.location.reload()
              throw new Error('token失效')
            }
            return result
          })
          .catch((error) => console.log("custome fetch error", error));
      },
      /**
       * Get方法
       * @param {*} url
       * @param {*} params
       * @returns
       */
      get(url, params, options) {
        if (params) {
          const queryParams = Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
            .join('&');
          url = url + '?' + queryParams;
          let paramsArray = [];
          Object.keys(params).forEach((key) =>
            paramsArray.push(`${key}=${params.key}`)
          );
          url +=
            url.indexOf("?") > -1 ? (url.indexOf("&") > -1 ? "&" : "") : "?";
        }
        return this.query(url, {
          method: 'GET',
          ...options,
        })
      },
      /**
       * post方法
       * @param {} url
       * @param {*} data
       * @returns
       */
      post(url, data, options) {
        if (data) {
          data = JSON.stringify(data)
        }
        return this.query(url, {
          method: 'POST',
          body: data,
          ...options,
        })
      },
      /** 清除登录 */
      clearLogin() {
        window.localStorage.removeItem('access_token')
        window.localStorage.removeItem('customer_uid')
        window.localStorage.removeItem('expire_access_token_time')
        window.localStorage.removeItem('reality_customer')
      },
      getTemporaryTustomer() {
        var temporary_customer = window.localStorage.getItem('temporary_customer') || ''
        if (temporary_customer) {
          return JSON.parse(temporary_customer)
        } else {
          return {}
        }
      },
      // 获取临时的token
      getTemporaryCustomerToken() {
        if (!temporaryPromise) {
          temporaryPromise = new Promise(async (resolve) => {
            var temporary_customer = window.localStorage.getItem('temporary_customer')
            if (!temporary_customer || !temporary_customer.includes('first_order_created_at')) {
              var {
                name,
                version
              } = getOsInfo()
              const result = await this.post('/user/device-register', {
                os: name,
                os_version: version,
                device_id: sensors?.store?._state?.$device_id || '',
                time_offset: new Date().getTimezoneOffset() / 60,
                language: Shopify.locale,
                country: Shopify.country,
                platform: window.getPlatFormType()
              });
              if (result && result.code == 200) {
                window.localStorage.setItem('temporary_customer', JSON.stringify(result.data))
                resolve(result.data)
              } else {
                resolve(null)
              }
            } else {
              resolve(JSON.parse(temporary_customer));
            }
          })
        }
        return temporaryPromise;
      },
      /** 临时处理401的问题 */
      async clearCustomerLogin() {
        try {
          window.localStorage.removeItem('access_token')
          window.localStorage.removeItem('temporary_customer')
          temporaryPromise = null
          loginPromise = null
          await this.customerLogin()
        } catch (err) {
          throw err
        }
      },
      /** 登录 */
      customerLogin() {
        if (!loginPromise) {
          loginPromise = new Promise(async (resolve, reject) => {
            const email = window.global.email
            if (!email) {
              this.clearLogin();
              await this.getTemporaryCustomerToken();
              resolve(null);
              return;
            }
            const expire_access_token_time = window.localStorage.getItem(
              "expire_access_token_time"
            );
            const access_token = window.localStorage.getItem("access_token");
            const reality_customer = window.localStorage.getItem("reality_customer");
            if (
              access_token &&
              expire_access_token_time &&
              Date.now() <
              Number(expire_access_token_time) + 20 * 24 * 60 * 60 * 1000 &&
              reality_customer
            ) {
              window.cartSynced = true; // 已经登录过了，可以开启购物车同步
              resolve(access_token);
              return;
            }
            this.post("/customer/login", {
              token: window.global.token,
              sign: window.btoa(
                `email=${window.global.email}&time=${window.global.time}`
              ),
            })
              .then(async (result) => {
                window.localStorage.setItem("access_token", result.data.token);
                window.localStorage.setItem(
                  "expire_access_token_time",
                  Date.now()
                );
                window.localStorage.setItem("customer_uid", result.data.uid);
                window.localStorage.setItem("reality_customer", JSON.stringify(result.data));
                window.localStorage.removeItem("temporary_customer"); // 清空资产id
                if (sensors) {
                  var site_code = window.Bloom.global.site_code;
                  sensors.login(`${site_code != 'SPUS' ? `${site_code}_` : ''}${result.data.uid}`); // 调用神策登录一下
                }
                resolve(result.data.token);
              })
              .catch((error) => reject(error))
          })
        }
        return loginPromise
      },
      /** 给结算页清除收藏购物车用的 */
      async cartSync(data) {
        await this.customerLogin();
        // if (islogin) {
        await theme.fetch.post("/cart/sync", {
          cart: data,
        })
        // }/
      },
      /**
       * uid
       * @param {*} email 
       * @param {*} type 1 转盘 2 订阅 3 下单
       */
      async uidSubscribe(email, type = 1) {
        this.post('/customer/uid-subscribe', {
          email,
          type
        })
      }
    };
  }
  if (window && window.theme) {
    const isIframe = window.Shopify && window.Shopify.isIframe;
    const gql_url = `${isIframe ? window.Bloom.global.graphql_api.url : window.Bloom.global.graphql_api.client_url}`;
    const gql_t = window.Bloom.global.graphql_api.token
    const ImageFragement = `fragment ImageFragement on Image {
      id
      height
      width
      src
      originalSrc
      altText
    }`;
    const PriceRangeFragement = `fragment PriceRangeFragement on ProductPriceRange {
      minVariantPrice {
        amount
      }
      maxVariantPrice {
        amount
      }
    }`;
    const VariantFragment = `fragment VariantFragment on ProductVariant {
      availableForSale
      id
      price {
        amount
      }
      priceV2 {
        amount
      }
      sku
      title
      quantityAvailable
      compareAtPrice {
        amount
      }
      compareAtPriceV2 {
        amount
      }
      selectedOptions {
        name
        value
      }
      image {
        url
      }
      metafields(identifiers: [{ key: "sales_country_list", namespace: "Product" }, { key: "warehouse_list", namespace: "Product" },
          { key: "preorder", namespace: "Product" }]) {
        key
        value
        type
      }
    }`;
    const OptionFragment = `fragment OptionFragment on ProductOption {
      name
      values
    }`;
    const MetafieldsFragment = `fragment MetafieldsFragment on Metafield {
      key
      namespace
      value
      type
    }`;
    const MetafieldsParams =
      '[{key: "sku_arriva_date", namespace: "Product"}, {key: "goods_details", namespace: "Product"}, {key: "product_functionalFabric", namespace: "Product"}, { key: "skc_picture_urls", namespace: "Product" }, { key: "product_option_merger", namespace: "Product" },  { key: "skc_attributes", namespace: "Product" }, {key: "sku_picture_point", namespace: "Product"}, {key: "product_activitys_configs", namespace: "Product"}]';
    theme.gql = {
      // gql简易请求封装
      query(data) {
        return fetch(gql_url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": gql_t,
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .catch((error) => console.error("gql fetch error"));
      },
      /**
       * 处理商品id
       * @param {*} ids
       * @returns
       */
      handleProductIds(ids) {
        return ids.map((item) => String(item).indexOf("gid://shopify/Product/") > -1 ? item : "gid://shopify/Product/" + item);
      },
      /**
       * 处理商品sku id
       * @param {*} ids
       */
      handleProductSkuIds(ids) {
        return ids.map((item) => String(item).indexOf("gid://shopify/ProductVariant/") > -1 ? item : "gid://shopify/ProductVariant/" + item);
      },
      /**
       * 获取商品数据
       * @param {*} ids
       * @returns
       */
      getProducts(ids) {
        var query_params = {
          query: `${ImageFragement}
            ${PriceRangeFragement}
            ${VariantFragment}
            ${OptionFragment}
            ${MetafieldsFragment}
            query Products($ids : [ID!]!) {
              nodes(ids:$ids){
                ... on Product{
                  id
                  handle
                  title
                  availableForSale
                  tags
                  createdAt
                  updatedAt
                  vendor
                  featuredImage {
                    ...ImageFragement
                  }
                  images(first: 200) {
                    nodes {
                      ...ImageFragement
                    }
                  }
                  media(first: 200) {
                    nodes {
                      ... on MediaImage {
                        id
                        image {
                          ...ImageFragement
                        }
                      }
                    }
                  }
                  priceRange {
                    ...PriceRangeFragement
                  }
                  compareAtPriceRange {
                    ...PriceRangeFragement
                  }
                  variants(first: 200) {
                    nodes {
                      ...VariantFragment
                    }
                  }
                  options(first: 200) {
                    ...OptionFragment
                  }
                  metafields(identifiers:${MetafieldsParams}) {
                    ...MetafieldsFragment
                  }
                }
              }
            }`,
          variables: {
            ids: this.handleProductIds(ids),
          },
        };
        return this.query(query_params);
      },
      /**
       * 获取商品列表数据
       * @param {*} ids
       * @returns
       */
      getProductsVarinats(ids) {
        var query_params = {
          query: `
          ${MetafieldsFragment}
          ${PriceRangeFragement}
          query ProductVariants($ids:[ID!]!){
            nodes(ids: $ids) {
              ... on ProductVariant {
                availableForSale
                barcode
                image {
                  id
                  height
                  width
                  url
                }
                currentlyNotInStock
                id
                quantityAvailable
                requiresShipping
                sku
                title
                weight
                weightUnit
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                product {
                  title
                  id
                  handle
                  tags
                  onlineStoreUrl
                  vendor
                  productType
                  availableForSale
                  priceRange {
                    ...PriceRangeFragement
                  }
                  compareAtPriceRange {
                    ...PriceRangeFragement
                  }
                  metafields(identifiers:${MetafieldsParams}) {
                    ...MetafieldsFragment
                  }
                }
              }
            }
          }`,
          variables: {
            ids: this.handleProductSkuIds(ids),
          },
        };
        return this.query(query_params);
      },
    };
  }
})()
